import React, { memo } from 'react'
import { makeStyles } from 'transfix-ui/core/styles'
import RecommendedShipmentsSection from 'apps/fleet-planner/components/recommendations/RecommendedShipmentsSection'
import ActiveShipmentsSection from '../ActiveShipmentsSection'
import HomepageHeader from '../HomepageHeader'
import PopularToolsSection from '../PopularToolsSection'
import SetupGuideSection from '../SetupGuideSection'
import ShipmentOffersSection from '../ShipmentOffersSection'
import ShipmentsNeedingAttentionSection from '../ShipmentsNeedingAttentionSection'

const useCarrierAppHomepageBodyStyles = makeStyles(theme => ({
  header: {
    marginBottom: theme.spacing(3),
  },
  headerSections: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    position: 'relative',

    [theme.breakpoints.up('md')]: {
      gap: theme.spacing(4),
      zIndex: 1300,
    },
  },
  body: {
    padding: 0,

    [theme.breakpoints.up('xl')]: {
      padding: `0px ${theme.spacing(4)}`,
    },
  },
  flex: {
    display: 'flex',
    gap: theme.spacing(4),
    flexDirection: 'column',
    margin: `${theme.spacing(3)} 0 ${theme.spacing(4)}`,

    [theme.breakpoints.up('xl')]: {
      flexDirection: 'row',
      gap: theme.spacing(3),
    },
  },
  activeLoads: {
    padding: `0px ${theme.spacing(2)}`,

    [theme.breakpoints.up('xl')]: {
      padding: 0,
      flexGrow: 1,
    },
  },
  popularTools: {
    [theme.breakpoints.up('xl')]: {
      '&.stacked': {
        flex: '0 0 350px',
      },
      '&.inline': {
        flexGrow: 1,
      },
    },
  },
  section: {
    padding: `0px ${theme.spacing(2)}`,

    [theme.breakpoints.up('xl')]: {
      padding: 0,
    },
  },
}))

export interface ICarrierAppHomepageBodyProps {}

const CarrierAppHomepageBody = memo<ICarrierAppHomepageBodyProps>(() => {
  const classes = useCarrierAppHomepageBodyStyles()

  return (
    <div>
      <div className={classes.header}>
        <HomepageHeader>
          <div className={classes.headerSections}>
            <SetupGuideSection />
            <ShipmentOffersSection />
          </div>
        </HomepageHeader>
      </div>
      <div className={classes.body}>
        <div className={classes.section}>
          <ShipmentsNeedingAttentionSection />
        </div>
        <div className={classes.flex}>
          <div className={classes.activeLoads}>
            <ActiveShipmentsSection />
          </div>
          <div className={`${classes.popularTools} stacked`}>
            <PopularToolsSection displayInline={false} />
          </div>
        </div>
        <div className={classes.section}>
          <RecommendedShipmentsSection title='Suggested Loads' />
        </div>
      </div>
    </div>
  )
})

export default CarrierAppHomepageBody
